import { render, staticRenderFns } from "./TabExtensions.vue?vue&type=template&id=50d30549&"
import script from "./TabExtensions.vue?vue&type=script&lang=js&"
export * from "./TabExtensions.vue?vue&type=script&lang=js&"
import style0 from "./TabExtensions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports